export default __webpack_public_path__ + "static/media/by_8.f9c35344.mp3";